import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Store";
import router from "./Router/Router";
import { RouterProvider } from "react-router-dom";
import { NavermapsProvider } from "react-naver-maps";
import { ThemeProvider } from "styled-components";
import theme from "@/themes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <NavermapsProvider ncpKeyId="2gto1g9is2">
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <div className="App">
                <RouterProvider router={router} />
              </div>
            </QueryClientProvider>
          </PersistGate>
        </Provider>
      </NavermapsProvider>
    </ThemeProvider>
  );
}

export default App;
